<template>
  <div>
    <h3 class="d-flex text--darken-1">
      <span>Family History <small><i>(Click a record to update)</i></small></span>
      <base-popup-btn
        v-if="consultation.status != 'submitted'"
        class="ml-auto"
        @click="addFamilyHistory"
      >
        Add Family History
      </base-popup-btn>
    </h3>
    
    <v-row>
      <v-col cols="12">
        <base-table
          :headers="headers"
          :items="family_history"
        >
          <template v-slot:item="{ item, index }">
            <tr @click="updateFamilyHistory(index)">
              <td>{{ item.relationship }}</td>
              <td>{{ item.health }}</td>
            </tr>
          </template>
        </base-table>
      </v-col>
    </v-row>

    <!-- ********************************** FAMILY DIALOG ********************************** -->

    <v-dialog
     v-model="familyHistoryDialog"
     content-class="elevation-0"
     width="70vw"
     max-width="600px" 
    >
      <v-card>
        <v-card-title class="primary--text">Family History</v-card-title>
        
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <!-- Allergy -->
            <v-text-field
              v-model="relationship"
              placeholder=" "
              :rules="rules.required"
              v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.relationship = `${this.relationship || ''} ${text}`;}, 'relationship')}"
              v-on:click="() => {this.$vtt.setModel('relationship');}"
            >
              <template v-slot:label>
                <h3>Relationship <span class="red--text">*</span></h3>
              </template>
            </v-text-field>

            <!-- Note -->
            <v-textarea
              v-model="health"
              placeholder=" "
              rows="3"
              v-on:focus="() => {this.$vtt.startSpeechListener((text) => { this.health = `${this.health || ''} ${text}`;}, 'health')}"
              v-on:click="() => {this.$vtt.setModel('health');}"
            >
              <template v-slot:label>
                <h3>Health Condition</h3>
              </template>
            </v-textarea>

            <VTTButton :mode="'checkbox'"/>
          </v-form>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="d-flex justify-center">
          <!-- Add/ Update Button -->
          <v-btn
            rounded
            small
            color="primary"
            class="px-6 mx-2"
            @click="saveFamilyHistory"
          >
            {{ familyHistoryUpdate?'Update':'Add' }}
          </v-btn>

          <!-- Remove Button -->
          <v-btn
            rounded
            small
            color="error"
            class="px-6 mx-2"
            v-if="familyHistoryUpdate"
            @click="removeFamilyHistory"
          >Remove</v-btn>

          <!-- Cancel Button -->
          <v-btn
            rounded
            small
            color="primary lighten-5"
            class="px-6 mx-2 primary--text"
            @click="cancelFamilyHistory"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ********************************** FAMILY DIALOG ********************************** -->

  </div>
</template>

<script>

  import VTTButton from '../../../../../components/custom/VTTButton.vue';
  import textreplacementmixin from '../../../../../mixins/textreplacementmixin';

  export default {
    name: 'FamilyHistory',
    components: { VTTButton },
    mixins: [textreplacementmixin],

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    data: () => ({
      valid: false,
      rules: {
       required: [value => !!value || "This field is required."]
      },
      familyHistoryDialog: false,
      familyHistoryUpdate: false,

      family: {
        health: "",
        relationship: "",
      },

      headers: [
        { text: 'Relationship', value: 'relationship', class:'primary--text' },
        { text: 'Health Condition', value: 'health', class:'primary--text' },
      ]
    }),

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    computed: {
      consultation() { return this.$store.getters['consultation/activeInfo'] },
      family_history: {
        get() { return this.$store.getters['patient/family_history'] },
        set(val) { this.$store.commit('patient/updateFamilyHistory', val) }
      },

      health: {
        get() { return this.$store.getters['patient/health'] },
        set(val) { this.$store.commit('patient/updateHealth', val) }
      },

      relationship: {
        get() { return this.$store.getters['patient/relationship'] },
        set(val) { this.$store.commit('patient/updateRelationship', val) }
      },
    },

    /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

    methods: {

      addFamilyHistory() {
        this.$store.commit('patient/clearFamilyHistory');        
        this.familyHistoryDialog = true,
        this.familyHistoryUpdate = false
      },

      updateFamilyHistory(index) {
        this.familyHistoryDialog = true,
        this.familyHistoryUpdate = true
        this.$store.commit('patient/setActiveFamilyHistory', index);
      },

      cancelFamilyHistory() {
        this.$refs.form.resetValidation();
        this.familyHistoryDialog = false;
        this.familyHistoryUpdate = false;
      },

      saveFamilyHistory() {
        this.$refs.form.validate();
        if (this.valid) {
          if (this.familyHistoryUpdate) {
            var index = this.$store.getters['patient/setActiveFamilyHistory'];
            this.$store.commit('patient/editFamilyHistory', index);
            this.familyHistoryDialog = false;
          } else {
            this.$store.commit('patient/addFamilyHistory');
            this.$store.commit('patient/clearFamilyHistory');
            this.familyHistoryDialog = false;
          }
        }
      },

      removeFamilyHistory() {
        this.$store.commit('patient/removeFamilyHistory');
        this.familyHistoryDialog = false;
      },
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    watch: {
      form: function (formData) {

        if(formData.doctor_family_history.length > 0) {
          formData.doctor_family_history.map(doctor_family_history => {

            console.log("family_history");
            console.log(doctor_family_history);

            let to_insert_case_family_history = {
              relationship: doctor_family_history.relationship,
              health: doctor_family_history.health,
            };

            this.relatives.push(to_insert_case_family_history);
          });
        }
      }
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    mounted() {
      console.log("family_history");
      console.log(this.form);
    }
  };
</script>

<style lang="scss" scoped>
  table {
    table-layout: fixed;
    width: 100%;

    th, td {
      text-align: left;
      padding-top: 5px;
      padding-bottom: 5px;
    }

    th {
      font-size: 12px;
      color: #258bf5;
    }

    /* scrollable tbody if content overlaps height */
    tbody {
      height: 150px;
      overflow: auto;
      display: block;
    }
    tr {
      display:table;
      width:100%;
      table-layout: fixed;
    }
  }
</style>